

require('./bootstrap');

window.Vue = require('vue');

/**
 * Our own components
 */
Vue.component('jambox', require('./components/Jambox').default);

const app = new Vue({
    el: '#app',
});

$(document).ready(function () {
    $('.alert-global').delay(7000).fadeOut();

    // toggle sidebar when button clicked
    $('.sidebar-toggle').on('click', function () {
        $('.sidebar').toggleClass('toggled');
    });

    // auto-expand submenu if an item is active
    var active = $('.sidebar .active');

    if (active.length && active.parent('.collapse').length) {
        var parent = active.parent('.collapse');

        parent.prev('a').attr('aria-expanded', true);
        parent.addClass('show');
    }
});
